// Prevent scroll chaining when menus are open by trapping wheel/touch events on scrollable menus.
export function attachScrollGuards(root: ShadowRoot): () => void {
  const queryAll = (selector: string, ctx: ParentNode = root) => Array.from(ctx.querySelectorAll(selector));
  const nodes = [
    ...queryAll('.dropdown-menu:not(.menu-apps)'),
    ...queryAll('.apps-list'),
    ...queryAll('.apps-sublinks'),
  ] as HTMLElement[];

  const onWheelOrTouch = (event: Event) => {
    const el = event.currentTarget as HTMLElement;
    const scrollable = el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
    if (!scrollable) event.preventDefault();
  };

  nodes.forEach((el) => {
    el.addEventListener('wheel', onWheelOrTouch as any, { passive: false });
    el.addEventListener('touchmove', onWheelOrTouch as any, { passive: false });
  });

  return () =>
    nodes.forEach((el) => {
      el.removeEventListener('wheel', onWheelOrTouch as any);
      el.removeEventListener('touchmove', onWheelOrTouch as any);
    });
}
